import { render, staticRenderFns } from "./ManualBordingFilters.vue?vue&type=template&id=8a354bba&scoped=true"
import script from "./ManualBordingFilters.vue?vue&type=script&lang=js"
export * from "./ManualBordingFilters.vue?vue&type=script&lang=js"
import style0 from "./ManualBordingFilters.vue?vue&type=style&index=0&id=8a354bba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a354bba",
  null
  
)

export default component.exports